<template>
  <role-only :role="'tech'">
    <img src="/img/dataforge-silver.svg" style="height: 1.5rem" class="pe-1" />
    <slot />
  </role-only>
</template>

<script>
import RoleOnly from './RoleOnly';

export default {
  components: { RoleOnly },
  props: {},
};
</script>
